export default __webpack_public_path__ + "static/media/Nickel2.d1249895.png";